import { Grid } from "@mui/material";

export const GridItem: React.FC<any> = ({ children }) => {
  return (
    <Grid item xl={4} md={6} sm={12} xs={12}>
      {children}
    </Grid>
  );
};
